import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileSourceType } from '../models/vdr-file-source-type.enum';

export interface ApproveVDRFileRemovalRequest {
    engagementId: number;
    fileId: number;
    fileSourceType: VDRFileSourceType;
}

export const ApproveVDRFileRemoval = createAsyncThunk(
    'dataRoom/approveFileRemoval',
    async (
        { engagementId, fileId, fileSourceType }: ApproveVDRFileRemovalRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `api/VirtualDataRoomDocument/${engagementId}/file/${fileId}/approve-removal?fileSourceType=${fileSourceType}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not approve file removal at the moment.',
                    'error'
                );
                throw new Error('Failed to approve file removal');
            }

            return fileId;
        } catch (error) {
            createNotification(
                'An error occurred while approving file removal.',
                'error'
            );
            throw error;
        }
    }
);

